import { replace } from "connected-react-router/immutable";

import routePaths from "app/routePaths";
import service from "services/app.service";
import { UserMapper } from "app/app.mappers";
import appService from "services/app.service";
import { APP_ACTIONS } from "app/app.constants";
import { makeActionCreator } from "utils/app.util";
import { getUserDefaultViewId } from "features/planner/planner.actions";

export const getCurrentUser = () => dispatch => {
  const payload = service.getCurrentUser();

  dispatch({
    type: APP_ACTIONS.GET_CURRENT_USER,
    payload,
  });

  return payload;
};

export const applicationOnLoad = () => dispatch => {
  const payload = Promise.all([
    dispatch(getCurrentUser()),
    dispatch(getUserDefaultViewId()),
  ]);

  dispatch({
    type: APP_ACTIONS.APPLICATION_ON_LOAD,
    payload,
  });

  return payload;
};

export const onUnauthorized = () => dispatch => {
  dispatch({
    type: APP_ACTIONS.GET_CURRENT_USER,
    payload: UserMapper.initial(),
  });
  dispatch(replace(routePaths.login));
};

export const togglePanel = panelId => dispatch =>
  dispatch({
    type: APP_ACTIONS.TOGGLE_PANEL,
    panelId,
  });

export const replacePanel = panelId => dispatch =>
  dispatch({
    type: APP_ACTIONS.REPLACE_PANEL,
    panelId,
  });

export const removeNotification = () => dispatch =>
  dispatch({
    type: APP_ACTIONS.REMOVE_NOTIFICATION,
  });

export const getAllAppRoles = makeActionCreator({
  type: APP_ACTIONS.GET_ALL_APP_ROLES,
  payload: appService.getAllAppRoles,
});

export const createUserAppRoles = makeActionCreator(
  {
    type: APP_ACTIONS.CREATE_USER_APP_ROLES,
    payload: appService.createUserAppRoles,
  },
  "userId",
);

export const setApplicationFailure = errorMessage => dispatch =>
  dispatch({
    type: APP_ACTIONS.SET_APPLICATION_FAILURE,
    payload: errorMessage,
  });
